import script from "./EquipamentosPage.vue?vue&type=script&setup=true&lang=js"
export * from "./EquipamentosPage.vue?vue&type=script&setup=true&lang=js"

import "./EquipamentosPage.vue?vue&type=style&index=0&id=ac672424&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-ac672424"]])

export default __exports__